import React from "react";
import { Table, TableProps, Box, ScrollArea } from "@mantine/core";

import styles from "@scss/custom-components/table-wrapper.module.scss";

export interface CustomTableProps extends TableProps {
  variant?: "default" | "no-background";
  height?: string | number;
}

export const CustomTable: React.FC<CustomTableProps> = ({
  variant = "default",
  className,
  height,
  children,
  ...props
}) => {
  return (
    <Box className={(className ? className + " " : "") + styles.tableWrapper}>
      <ScrollArea
        h={height}
        w={{ base: "100vw", sm: "100%" }}
        maw={"100%"}
        type="hover"
        offsetScrollbars={false}
      >
        <Table data-variant={variant} {...props}>
          {children}
        </Table>
      </ScrollArea>
    </Box>
  );
};
